import * as yup from 'yup'

export const FixedRoutePricingSchema = yup.object().shape({
  fixedRouteId: yup.number().required('Please select a route.'),
  price: yup.number().required('Please enter a price.'),
  vehicleIds: yup
    .array()
    .of(yup.number())
    .min(1, 'Please select at least one taxi.')
    .required('Please select a taxi.'),
})
